import React, { useEffect } from "react";
import Footer from "./Footer";
import HeartGif from "../assets/red-heart-bumping.gif";
import EnquiryForm from "./custom/EnquiryForm";
import AdmContactUsImg from "../assets/AdmContactUs.svg";
import { Helmet } from "react-helmet";

const GetInTouch = () => {
  window.scrollTo(0, 10);

  return (
    <div>
      <Helmet>
        <title>Contact Mother's Pride Preschool – Reach Out to India's Leading Preschool</title>
        <meta name="description" content="Have questions or need assistance? Contact Mother's Pride Preschool today. We're here to help you with admissions, programs, and any inquiries you may have." />
        <meta name="keywords" content="Contact Mother's Pride, Mother's Pride preschool contact, Mother's Pride enquiry" />
        <link rel="canonical" href="https://www.motherspridepreschool.com/getinTouch" />
      </Helmet>
      <div className="bg-[#FFF3ED] min-h-screen py-10">
        <div className="container mx-auto pb-[40px] lg:mt-[2rem]">
          <div className="flex flex-col lg:flex-row justify-between gap-10 px-[4%] sm:px-[8%] ">
            {/* Left Section */}
            <div className="lg:w-1/2 flex flex-col gap-4  ">
              <div className="flex gap-3 items-center">
                <h1 className="text-[2rem] sm:text-[60px] sm:leading-[72px] font-normal text-[#D31C4F] sm:mb-6 relative font-Wonderbar">
                  Get in <span className="text-black">Touch</span>
                </h1>
                <img
                  src={HeartGif}
                  className=" w-7 h-7 sm:h-[50px] sm:mb-5 sm:w-[50px]"
                  alt="heartGif"
                />
              </div>
              <p className="text-xl sm:text-2xl sm:leading-8 text-black">
                Have an enquiry or want to know how it works? <br /> Fill the
                form
              </p>

              <div className="text-black flex flex-col gap-2 sm:gap-4">
                <p className="font-bold text-lg leading-[42px]">
                  Mother's Pride Office
                </p>
                <p className="font-normal text-[20px] leading-[30px]">
                  11/77, West Punjabi Bagh, New Delhi - 110026
                </p>
                <p className="text-[18px] sm:text-[20px] font-semibold leading-[30px]">
                  📞 +91 7838654186, +91 7290011862
                </p>
                <p className="text-[18px] sm:text-[20px] font-semibold leading-[30px]">
                  ✉️ info@motherspridepreschool.com
                </p>
              </div>

              <img
                src={AdmContactUsImg}
                alt="Girl Child"
                className="w-[100%] mx-auto lg:mx-0 mt-10"
              />
            </div>

            {/* Right Section (Form) */}
            <div className="lg:w-[50%] ">
              <EnquiryForm width={"100%"} enquirySource={"ContactUs"} />
            </div>
          </div>
        </div>

        <div className="bg-white sm:pb-[80px] px-[8%]">
          <div className="pt-8 sm:pt-16  flex flex-col gap-4">
            <h2 className="text-2xl sm:text-[42px] leading-[46px] font-Wonderbar  ">
              Franchise <span className="text-[#D31C4F]"> Benefits</span>
            </h2>
            <p className="text-[#D31C4F] font-medium font-Lato sm:text-[20px] leading-7">
              In order to start the Mother's Pride play school the first & basic
              requirement is that the partner should love kids and have a
              passion to do this business with a long term vision. We at
              Mother's Pride believe that alliances are an integral part of
              contemporary strategic businesses. We always look out for good
              business partners who can share our vision, articulate it,
              passionately own our vision, and relentlessly drive it to
              completion.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-[40px]">
            <div className="lg:pr-12">
              <h1 className="text-2xl sm:text-[28px] font-bold leading-[42px]">
                About Mother's Pride
              </h1>
              <p className=" mt-3 font-normal sm:text-[20px] leading-[30px]">
                The journey of Mother's Pride began in 1996 with its first
                branch at Paschim Vihar. From then on, Mother's Pride became the
                trendsetter for preschool education. Today, Mother's Pride is
                one of the largest preschool chains with over 95 branches and
                many more are on the way. Mother's Pride remains the only
                preschool with a research and development department. All the
                teachers undergo rigorous training and are continuously educated
                about new revelations in child psychology.
              </p>
            </div>

            <div>
              <h1 className="text-2xl sm:text-[28px] font-bold leading-[42px]">
                About Marvel Group
              </h1>
              <p className=" mt-3 font-normal sm:text-[20px] leading-[30px]">
                Mother's Pride is part of the Marvel Group. Marvel Group ranks
                amongst India's top business houses. Marvel Group has business
                interests that range from education to healthcare. Other brands
                under Marvel Group are Presidium, Adiva, Sparsh and The
                Knowledge Tree.
              </p>
            </div>
            <div className="lg:pr-12">
              <h1 className="text-2xl sm:text-[28px] font-bold leading-[42px]">
                Who Can Start
              </h1>
              <p className=" mt-3 font-normal sm:text-[20px] leading-[30px]">
                We are looking for partners who love kids and have a passion to
                do this business with a long-term vision. In order to start the
                Mother's Pride play school, the first and basic requirement is
                that the partner should love kids and have a passion to do this
                business with a long term vision. Along with that you should own
                an area between 1500 sq ft – 10000 sq. ft. With an investment
                capacity ranging between Rs. 15 lakh to Rs.3 crore depending
                upon the area and location.
              </p>
            </div>

            <div>
              <h1 className="text-2xl sm:text-[28px] font-bold leading-[42px]">
                Why Mother's Pride
              </h1>
              <ul
                style={{ listStyleType: "disc", marginTop: "10px" }}
                className="font-normal sm:text-[20px] lg:ml-[20px] ml-[21px] sm:mb-0 mb-10 leading-[30px] gap-3"
              >
                <li>
                  One of the strongest brands of preschools with the maximum
                  recall among parents
                </li>
                <li>
                  More than 95 branches in Delhi, NCR and other parts of India
                </li>
                <li>
                  Almost two decades of proven success, expertise and experience
                </li>
                <li>
                  Worldwide recognition. We are the only pre-school in India to
                  have won a Gold Cannes.
                </li>
                <li>
                  The only preschool with a research and development department
                  to develop and update our child centric curriculum
                </li>
                <li>Focus on teacher training and recruiting of best talent</li>
              </ul>
            </div>
          </div>
        </div>
        <Footer marginX={"8%"} />
      </div>
    </div>
  );
};

export default GetInTouch;
